/**
 * Copyright © Veeam Software Group GmbH.
 */

import { useContext } from 'react';

import { ProtectedMicrosoft365ObjectsContext } from '../contexts/ProtectedMicrosoft365ObjectsContext';

export const useProtectedMicrosoft365ObjectsStore = () => useContext(ProtectedMicrosoft365ObjectsContext);
